const ProfileIcon = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={31} fill="none" {...props}>
        <path
            stroke={props.color}
            strokeLinecap="round"
            strokeWidth={2}
            d="M1.261 26.135c2.194-3.659 7-6.162 14.5-6.162s12.307 2.503 14.5 6.162M21.72 7.27a5.957 5.957 0 1 1-11.915 0 5.957 5.957 0 0 1 11.915 0Z"
        />
    </svg>
);
export default ProfileIcon;
